import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertTeamLeader = createAsyncThunk('insertTeamLeader', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertTeamLeaderEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});



export const updateTeamLeader = createAsyncThunk('updateTeamLeader', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateTeamLeader`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});



export const fetchTeamLeader = createAsyncThunk('fetchTeamLeader', async (id) => {
    try {
        const endpoint = id ? `getTeamLeaderReg&teamId=${id}` : 'getTeamLeaderReg';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});



const teamLeaderApiSlice = createSlice({
    name: 'TeamLeaderDatalist',
    initialState: {
        isLoading: false,
        teamLeader: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchTeamLeader.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchTeamLeader.fulfilled, (state, action) => {
            state.isLoading = false;
            state.teamLeader = action.payload;
        });
        builder.addCase(fetchTeamLeader .rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
      
    }
});

export default teamLeaderApiSlice.reducer;
